import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import * as api from '../../services/hotkey_template/api_hotkey_template';
import * as apiCommon from '../../services/apiCommon';
import * as common from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';




export function* fetchListHotkeyTemplateSaga(feathersApp) {
  yield takeLatest('FETCH_LIST_HOTKEY_TEMPLATE', callListHotkeyTemplate, feathersApp);
}
function* callListHotkeyTemplate(feathersApp, action) {
  const { filters, silent } = action;
  yield common.showProgressListTable(silent);
  try {
    const dataParams = {
      filters,
      list_type: 'hotkey_template'
    };
    const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
    yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}




export function* deleteHotkeyTemplateFromListSaga(feathersApp) {
  yield takeEvery('DELETE_HOTKEY_TEMPLATE_FROM_LIST', callDeleteHotkeyTemplateFromList, feathersApp);
}
function* callDeleteHotkeyTemplateFromList(feathersApp, action) {
  yield deleteHotkeyTemplate(feathersApp, action);
  yield delay(2000);
  yield callListHotkeyTemplate(feathersApp, { silent: true });
}
function* deleteHotkeyTemplate(feathersApp, action) {
  yield put({ type: 'DELETE_RECORD_INPROGRESS' });
  try {
    const { id } = action;
    let result = null;
    if (id) {
      const state = yield select();
      const { tenant, user } = state;
      const params = { tenant, user, id };
      result = yield call(api.deleteHotkeyTemplate, feathersApp, params);
      yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.ENTITY } });
      yield delay(2000);
      yield callListHotkeyTemplate(feathersApp, { silent: true });
    }
    return result;
  } catch (error) {
    yield put({ type: 'DELETE_RECORD_ERROR', error })
  }
}




export function* deleteHotkeyTemplateSaga(feathersApp) {
  yield takeEvery('DELETE_HOTKEY_TEMPLATE', callDeleteHotkeyTemplate, feathersApp);
}
function* callDeleteHotkeyTemplate(feathersApp, action) {
  yield put({ type: 'DELETE_RECORD_INPROGRESS' });
  try {
    const { id, fromList } = action;
    if (id) {
      const state = yield select();
      const { tenant, user } = state;
      const { id } = action;
      const params = { tenant, user, id };
      yield call(api.deleteHotkeyTemplate, feathersApp, params);
    }
    yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.ENTITY } });
    if (!fromList) {
      browserHistory.push('/admin/hotkey/template');
    } else {
      yield callListHotkeyTemplate({ silent: true });
    }

  } catch (error) {
    yield put({ type: 'DELETE_RECORD_ERROR', error })
  }
}




export function* fetchHotkeyTemplateForEditSaga(feathersApp) {
  yield takeEvery('FETCH_HOTKEY_TEMPLATE_BY_ID', callFetchHotkeyTemplateForEdit, feathersApp);
}
function* callFetchHotkeyTemplateForEdit(feathersApp, action) {
  const { tenant, user } = yield select();
  const { id } = action;
  const docType = DocType.HOTKEY_TEMPLATE;
  try {
    if (id) {
      yield put({ type: "FETCH_DATA_BY_ID_INPROGRESS", payload: { docType, id } });
      const fetchParams = { tenant, user, id };
      const doc = yield call(api.fetchHotkeyTemplateForEdit, feathersApp, fetchParams);
      yield common.doneDataById(doc);
    }
  } catch (error) {
    yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
  }
}
